import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'react-fela';
import { logoDarkOrLight } from 'utils/helpers';
import createComponent from 'styles/fela/createComponent';
import { ITEM_MODE } from 'components/VideoItems/constants';
import { imageTypes } from 'components/Image/Image';

const Container = createComponent(({ theme, mode }) => {
  const styles = {
    position: 'relative',
    borderRadius: theme.radius.poster,
    overflow: 'hidden',
    boxShadow: theme.hideThumbnailShadow ? 'none' : '0 2px 8px rgba(0, 0, 0, 0.2)',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
  };

  if (mode === ITEM_MODE.LIST) {
    styles.width = `${imageTypes.poster.width}rem`;
    styles.height = `${imageTypes.poster.height}rem`;
  }

  return styles;
}, 'div', ['mode']);

const PosterBox = createComponent(({ theme }) => ({
  backgroundColor: theme.color.imageBackground,
  aspectRatio: '2/3',
  position: 'relative',
}));

const LogoContainer = createComponent(({ theme }) => ({
  position: 'absolute',
  top: theme.margin.fine,
  left: theme.margin.fine,
  right: theme.margin.fine,
  height: `calc(100% - ${theme.margin.medium})`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const LogoImage = createComponent(() => ({
  maxWidth: '100%',
  maxHeight: '100%',
}), 'img');

const ChannelTitle = createComponent(({ theme }) => ({
  color: theme.color.primary,
  fontSize: theme.fontSize.small,
  textAlign: 'center',
  padding: theme.margin.fine,
  wordBreak: 'break-word',
}), 'div');

const ChannelPoster = ({ 
  viewable, 
  displayMode,
}) => {
  const theme = useContext(ThemeContext);
  const logoUrl = logoDarkOrLight(viewable, theme);

  return (
    <Container 
      mode={displayMode}
    >
      <PosterBox>
        <LogoContainer>
          {logoUrl ? (
            <LogoImage
              src={logoUrl}
              alt={viewable.title}
            />
          ) : (
            <ChannelTitle>{viewable.title}</ChannelTitle>
          )}
        </LogoContainer>
      </PosterBox>
    </Container>
  );
};

ChannelPoster.propTypes = {
  viewable: PropTypes.shape({
    title: PropTypes.string.isRequired,
    logoDark: PropTypes.string,
    logoLight: PropTypes.string,
  }).isRequired,
  displayMode: PropTypes.string,
};

ChannelPoster.displayName = 'ChannelPoster';

export default ChannelPoster;
